import React from 'react';
import cx from 'classnames';
import ReactTooltip from 'react-tooltip';

import { randomArray } from 'utils/randomArray';

import { useDriverDayFiltered } from 'modules/job-review/service';
import JobReviewListHeader from 'modules/job-review/list-header';
import JobReviewListItem from 'modules/job-review/list-item';

import { ReactComponent as EmptyStateIcon } from 'assets/icons/empty-state-gatekeeping.svg';
import { injectIntl } from 'react-intl';

const JobReviewList = ({ className, reduced, parentUrl, intl }) => {
  const { driverDayGrouped } = useDriverDayFiltered({ suspense: true });
  const t = intl.messages.modules.job_review;
  const groupedKeys = Object.keys(driverDayGrouped);
  const hasItems = groupedKeys.length > 0;

  if (!hasItems) {
    return (
      <div
        className={cx(`${className}__no-results`, {
          reduced: reduced,
        })}
      >
        <div className="icon">
          <EmptyStateIcon />
        </div>
        <div className="title">{t.no_results}</div>
        <div>{t.wide_search}</div>
      </div>
    );
  }

  return (
    <>
      <div
        className={cx(className, {
          reduced: reduced,
        })}
      >
        {groupedKeys.map((date) => (
          <div key={date}>
            <JobReviewListHeader date={date} total={driverDayGrouped[date].length} />
            {driverDayGrouped[date].map((driverDay) => (
              <JobReviewListItem
                key={driverDay.id}
                driverDay={driverDay}
                reduced={reduced}
                to={`${parentUrl}/${driverDay.id}`}
              />
            ))}
          </div>
        ))}
      </div>
      <ReactTooltip id="reasons-tooltip" effect="solid" />
    </>
  );
};

const JobReviewListEmpty = ({ className, reduced }) => {
  return (
    <div
      className={cx(className, {
        reduced: reduced,
      })}
    >
      <JobReviewListHeader loading reduced={reduced} />
      {randomArray(5, 20).map((key) => (
        <JobReviewListItem key={key} loading reduced={reduced} />
      ))}
    </div>
  );
};

export default injectIntl(JobReviewList);
export { JobReviewListEmpty };
